import React from "react";
import { Box, Typography } from "@mui/material";

const EmptyList = ({ children }) => {
  return (
    <Box mt={3}>
      <Typography
        variant="h6"
        align="center"
      >
        Няма намерени резултати.
      </Typography>
      {children}
    </Box>
  );
};

export default EmptyList;
